import React from "react";
import classNames from "classnames";
import getClassNameFactory from "../../../../utilities/classNames";
import ArrowRightIcon from "@dcl/icons/esm/ui/arrow-right";

var NavItem = function NavItem(_ref) {
  var description = _ref.description,
      href = _ref.href,
      summary = _ref.summary,
      title = _ref.title;
  var getClassName = getClassNameFactory("SiteHeaderNavItem");
  return /*#__PURE__*/React.createElement("li", {
    className: getClassName({
      modifiers: classNames({
        summary: summary
      })
    })
  }, /*#__PURE__*/React.createElement("a", {
    className: getClassName({
      descendantName: "link"
    }),
    href: href,
    role: "menuitem"
  }, /*#__PURE__*/React.createElement("span", {
    className: getClassName({
      descendantName: "linkInner"
    })
  }, /*#__PURE__*/React.createElement("span", {
    className: getClassName({
      descendantName: "linkText"
    })
  }, title), summary ? /*#__PURE__*/React.createElement("span", {
    className: getClassName({
      descendantName: "linkIcon"
    })
  }, /*#__PURE__*/React.createElement(ArrowRightIcon, null)) : null), description && !summary ? /*#__PURE__*/React.createElement("span", {
    className: getClassName({
      descendantName: "linkDescription"
    })
  }, description) : null));
};

NavItem.displayName = "SiteHeader.NavItem";
export default NavItem;